var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSkipBackwards = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7076 4.29242C26.0975 4.68231 26.0975 5.31444 25.7076 5.70434L15.8355 15.5764C15.6016 15.8104 15.6016 16.1896 15.8355 16.4236L25.7076 26.2957C26.0975 26.6856 26.0975 27.3177 25.7076 27.7076C25.3177 28.0975 24.6856 28.0975 24.2957 27.7076L14.4236 17.8355C13.4099 16.8218 13.4099 15.1782 14.4236 14.1645L24.2957 4.29242C24.6856 3.90253 25.3177 3.90253 25.7076 4.29242Z",
    fill: "#0D0F13"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 4.01949C7.55228 4.01949 8 4.4672 8 5.01949V27.0195C8 27.5718 7.55228 28.0195 7 28.0195C6.44772 28.0195 6 27.5718 6 27.0195V5.01949C6 4.4672 6.44772 4.01949 7 4.01949Z",
    fill: "#0D0F13"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSkipBackwards);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/skip_backwards.742bd5cf6199815fdf93e917d4f3f10c.svg";